
define(function(){
	const Backbone = require('backbone');
	const IPS = require('../base/ipsModelCollection')
    const builder = require('civicsUtils/buildUrlParameters');

	return IPS.extend({
		urlRoot : '/delegate/civics-api/api/cdr/applications/project',
		url:function(){
			var parameters = ''
			if(this.urlParms!=undefined){
				builder.buildUrlParameters(this.urlParms)
			}
			return this.urlRoot+parameters;
		}
	});
});
